<template lang="pug">
  .select-seat(v-if="isLoading")
    .spinner.large.center
      span.text 處理中
      .bounce.bounce1
      .bounce.bounce2
      .bounce.bounce3
  .select-seat(v-else-if="!isLoading")
    h4.title 選擇 {{ getBookingSelected.area }} 區 座位
    .mb-3
    .section-wrap.info-schedule(v-if="isLogin", :style="{maxWidth: (column * 50) + 'px'}", style="margin: 20px auto;")
      .content.border-styled(v-if="!getUser.registered.me")
        img.icon(src="~assets/submit-success-icon.png")
        span 尚未購票
        router-link.btn.ghost-btn(style="float:right;", :to="{name: 'ticketType'}") 立即購票
      .content.border-styled(v-if="getUser.registered.me && getUser.registered.me.status !== 4")
        img.icon(src="~assets/submit-success-icon.png")
        span.status(v-if="getUser.registered.me") {{ getUser.registered.me.status_string }}
        hr
        span 請先購票且完成付款，方可劃位
      .content.border-styled(v-else, :style="{maxWidth: (column * 50) + 'px'}", style="margin: 20px auto;")
        img.icon(src="~assets/submit-success-icon.png")
        span 點選位置 -> 指派帳號 -> 送出劃位資料
    .mb-10
    .account-wrap(v-if="getSeats.group")
      ul.selected-group
        h4 已選擇座位
        li(v-if="(getSeats.group.chosen && getSeats.group.chosen.length > 0 === false) && memberInfo.length === 0")
          span 尚無人劃位
        li(v-else, v-for="member in getSeats.group.chosen")
          .left
            span.icon
          .right
            .mySeat {{ member.section }}{{ member.human_seat_x }}{{ member.human_seat_y}}
            .account {{ member.account }}
        li(v-for="member in memberInfo")
          .left
            span.icon
          .right
            .mySeat {{ member.section }}{{ member.human_seat_x }}-{{ member.human_seat_y}}
            .account {{ member.account }}
      ul.unselected-group
        h4 未選擇座位
        li(v-if="(getSeats.group.unChosen && getSeats.group.unChosen.length > 0 === false)")
          span 全數劃位完成
        li(v-if="getSeats.group.unChosen && selectedId(member) < 0", v-for="member in getSeats.group.unChosen")
          span.icon
          span {{ member.account }}
          span {{ member.email }}
    .account-wrap
      h4 選位教學
      img(src="~assets/steps-help.png")
    .select-marked(:style="{maxWidth: (column * 50) + 'px'}")
      h4 區域標誌
      .marked.silent
        .icon
        .text 潛水區
      .marked.integrated
        .icon
        .text 綜合遊戲區
      .marked.steam
        .icon
        .text Steam區
      .marked.lol
        .icon
        .text 英雄聯盟區
      .marked.fps
        .icon
        .text 射擊遊戲區
      .marked.blizzard
        .icon
        .text 暴雪遊戲區
      .marked.warfare
        .icon
        .text 戰史遊戲區
      .marked.home
        .icon
        .text 無限制區
    h1(style="text-align: center; margin-top:60px") {{ getBookingSelected.area }} 區
    .stage: img(src="~assets/stage.png", @click="isHacked = !isHacked")
    .select-wrap(:style="{width: (column * 50) + 'px'}")
      .seat-number.horizon(v-for="num in column")
        span {{ num }}
      .seat-number.column(v-for="num in horizon", :style="{top: (num * 38) - 6 + 'px'}")
        span {{ num }}
      .seats-wrap(:style="{width: (column * 50) + 'px'}")
        .seat(v-if="isMobile === false", v-for="seat in getSeats.seats",
              :class="{selected: isSelected(seat.human_seat), blank: seat.status_string === 'blank', sold: seat.status === true || seat.status === false, notallow: seat.is_scope_allow === false, isMe: seat.is_me === true, isMember: seat.is_group_member, isHacked: isHacked && seat.status, steam: getBookingSelected.area === 'A' && seatsGroup.steam.indexOf(seat.human_seat) > -1, fps: getBookingSelected.area === 'A' && seatsGroup.fps.indexOf(seat.human_seat) > -1, integrated: getBookingSelected.area === 'B' && seatsGroup.integrated.indexOf(seat.human_seat) > -1, lol: getBookingSelected.area === 'B' && seatsGroup.lol.indexOf(seat.human_seat) > -1, blizzard: (getBookingSelected.area === 'C' && seatsGroup.blizzardC.indexOf(seat.human_seat) > -1) || (getBookingSelected.area === 'D' && seatsGroup.blizzardD.indexOf(seat.human_seat) > -1), silent: getBookingSelected.area === 'D' && seatsGroup.silent.indexOf(seat.human_seat) > -1 , warfare: getBookingSelected.area === 'C' && seatsGroup.warfare.indexOf(seat.human_seat) > -1 , home: getBookingSelected.area === 'C' && seatsGroup.home.indexOf(seat.human_seat) > -1 }",
              v-on:mouseenter="showInfo($event, seat)", v-on:mouseleave="hideInfo",
              @click="selectEvent(seat)")
          //- div {{ seat.human_seat }}
          //- div {{ seat.seat_no }}
        .seat(v-if="isMobile === true", v-for="seat in getSeats.seats",
              :class="{selected: isSelected(seat.human_seat), blank: seat.status_string === 'blank', sold: seat.status === true || seat.status === false, notallow: seat.is_scope_allow === false, isMe: seat.is_me === true, isMember: seat.is_group_member, isHacked: isHacked && seat.status, steam: getBookingSelected.area === 'A' && seatsGroup.steam.indexOf(seat.human_seat) > -1, fps: getBookingSelected.area === 'A' && seatsGroup.fps.indexOf(seat.human_seat) > -1, integrated: getBookingSelected.area === 'B' && seatsGroup.integrated.indexOf(seat.human_seat) > -1, lol: getBookingSelected.area === 'B' && seatsGroup.lol.indexOf(seat.human_seat) > -1, blizzard: (getBookingSelected.area === 'C' && seatsGroup.blizzardC.indexOf(seat.human_seat) > -1) || (getBookingSelected.area === 'D' && seatsGroup.blizzardD.indexOf(seat.human_seat) > -1), silent: getBookingSelected.area === 'D' && seatsGroup.silent.indexOf(seat.human_seat) > -1 , warfare: getBookingSelected.area === 'C' && seatsGroup.warfare.indexOf(seat.human_seat) > -1 , home: getBookingSelected.area === 'C' && seatsGroup.home.indexOf(seat.human_seat) > -1}",
              @click="selectEvent(seat)")
        .hover-box(v-if="boxSwitch", :style="{left: boxPosition.x + 'px', top: boxPosition.y + 'px'}")
          .seatId {{ seatInfo.seatNum }}
          //- .seatId A12
          .account {{ seatInfo.account }}
    //- hr
    //- DEMO
    //- .select-wrap(:style="{width: (column * 50) + 'px'}")
      .seat-number.horizon(v-for="num in column")
        span {{ num }}
      .seat-number.column(v-for="num in horizon", :style="{top: (num * 38) - 6 + 'px'}")
        span {{ num }}
      .seats-wrap(:style="{width: (column * 50) + 'px'}")
        .seat(v-if="isMobile === false", v-for="(seat, index) in seats", :class="{selected: isSelected(seat), blank: isBlank(seat), sold: isSold(seat)}", @click="selectEvent(seat)", v-on:mouseenter="showInfo($event, seat)", v-on:mouseleave="hideInfo")
          //- div {{ seat }}
        .seat(v-if="isMobile === true", v-for="seat in seats", :class="{selected: isSelected(seat), blank: isBlank(seat), sold: isSold(seat)}", @touchstart="selectEventMobile(seat)")
          //- div {{ seat }}
        .hover-box(v-if="boxSwitch", :style="{left: boxPosition.x + 'px', top: boxPosition.y + 'px'}")
          .seatId seatNum: {{ seatInfo.seatNum }}
          //- .seatId A12
          .account g8Open

    //- FOR TEST
    //- hr
    //- .select-wrap(:style="{width: (column * 50) + 'px'}")
      .seat-number.horizon(v-for="num in column")
        span {{ num }}
      .seat-number.column(v-for="num in horizon", :style="{top: (num * 38) - 6 + 'px'}")
        span {{ num }}
      .seats-wrap(:style="{width: (column * 50) + 'px'}")
        .seat(v-if="isMobile === false", v-for="seat in seats", :class="{selected: isSelected(seat), blank: isBlank(seat), sold: isSold(seat)}", @click="selectTest(seat)", v-on:mouseenter="showInfo($event, seat)", v-on:mouseleave="hideInfo")
        //- .seat(v-if="isMobile === true", v-for="seat in seats", :class="{selected: isSelected(seat), blank: isBlank(seat), sold: isSold(seat)}", @touchstart="selectEventMobile(seat)")
          //- div {{ seat }}
        //- .hover-box(v-if="boxSwitch", :style="{left: boxPosition.x + 'px', top: boxPosition.y + 'px'}")
          .seatId A12
          .account g8Open
    hr
    .btn-wrap
      .btn.ghost-btn.pre-btn(@click="$router.go(-1)") 上一步
      span(v-if="this.getUser.registered.me && this.getUser.registered.me.status === 4")
        .btn.ghost-btn.next-btn(v-if="getSeats.group && getSeats.group.unChosen", :disabled="this.submitData.register_id.length === 0", @click="submitButton")
          .spinner(v-if="submitDisabled")
            span.text 處理中
            .bounce.bounce1
            .bounce.bounce2
            .bounce.bounce3
          span(v-else) 送出
        .btn.ghost-btn.next-btn(v-if="getSeats.group && getSeats.group.unChosen", @click="submitClear", :disabled="this.submitData.register_id.length === 0", style="margin-right:10px;") 重置已選位置

    .scroll-tip(v-if="isMobile && !isLoading && isTip", @click="isTip = false")
      .content
        img.arrow(src="~assets/mobile-scroll-tip-arrow.png")
        img.hand(src="~assets/mobile-scroll-tip-hand.png")
        .text(style="text-align:center; margin-top:8px;") 座位圖可左右滑動

    //- .console
      //- label seats
      //- input(name="seats", @keyup="toNumeric($event)", type="number")
      //- label column
      //- input(name="column", @keyup="toNumeric($event)", type="number")
      //- label horizon
      //- input(name="horizon", @keyup="toNumeric($event)", type="number")
      //- div blank: {{ blank }}
      //- div sold: {{ sold }}
      div selected: {{ selected }}
      div
        span(v-for=" i in 400") {{ i }}, 
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'selectSeats',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log(vm.isLogin)
      if (vm.getBookingSelected.area !== '') {
        // vm.isLoading = false
      } else {
        vm.$router.push({name: 'selectArea'})
      }
    })
  },
  props: {
    isMobile: {
      type: Boolean
    },
    isLogin: {
      type: Boolean
    }
  },
  data () {
    return {
      isLoading: true,
      isTip: true,
      isHacked: false,
      submitDisabled: false,
      seats: 300,
      column: 12,
      horizon: 0,
      blank: [],
      sold: [],
      selected: [],
      memberInfo: [],
      submitData: {
        register_id: [],
        section: [],
        seat: []
      },
      boxSwitch: false,
      boxPosition: {
        x: 0,
        y: 0
      },
      seatInfo: {
        seatNum: 0,
        account: ''
      },
      section: {
        A: {
          column: 12,
          horizon: 26,
          seats: 312,
          blank: [107, 108, 119, 120, 131, 132, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 295, 296, 297, 298, 307, 308, 309, 310]
        },
        B: {
          column: 12,
          horizon: 26,
          seats: 312,
          blank: [97, 98, 107, 108, 109, 110, 119, 120, 121, 122, 131, 132, 133, 134, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 291, 292, 303, 304]
        },
        C: {
          column: 10,
          horizon: 28,
          seats: 280,
          blank: [1, 2, 5, 6, 7, 8, 11, 12, 15, 16, 17, 18, 21, 22, 31, 32, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 245, 246, 247, 248, 255, 256, 257, 258, 265, 266, 267, 268, 275, 276, 277, 278]
        },
        D: {
          column: 12,
          horizon: 28,
          seats: 336,
          blank: [3, 4, 5, 6, 11, 12, 15, 16, 17, 18, 23, 24, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 291, 292, 303, 304, 315, 316, 317, 318, 323, 324, 327, 328, 329, 330, 335, 336]
        }
      },
      seatsGroup: {
        silent: [169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334],
        integrated: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96],
        steam: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96],
        lol: [99, 100, 101, 102, 103, 104, 105, 106, 111, 112, 113, 114, 115, 116, 117, 118, 123, 124, 125, 126, 127, 128, 129, 130, 135, 136, 137, 138, 139, 140, 141, 142, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312],
        fps: [97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 145, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312],
        blizzardC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120],
        blizzardD: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144],
        warfare: [141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200],
        home: [201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280]
      }
    }
  },
  computed: {
    ...mapGetters([
      'getUser',
      'getBookingSelected',
      'getSeats'
    ])
  },
  mounted () {
    if (this.getBookingSelected.area !== '') {
      let area = this.getBookingSelected.area
      this.seats = this.section[area].seats
      this.column = this.section[area].column
      this.horizon = this.section[area].horizon
      this.blank = this.section[area].blank
      this.horizon = Math.ceil(this.seats / this.column)
      if (this.isLogin === false) {
        this.fetchSeatsGuest(this.getBookingSelected.area).then((res) => {
          this.isLoading = false
        })
      } else {
        // this.fetchSeatsGuest(this.getBookingSelected.area)
        this.fetchSeats(this.getBookingSelected.area).then((res) => {
          this.fetchRegistered().then(this.isLoading = false)
        })
        this.fetchPayment()
      }
    } else {
      this.$router.push({name: 'selectArea'})
    }
  },
  updated () {
    // console.log('Seats updated')
  },
  methods: {
    ...mapActions([
      'fetchSeats',
      'fetchSeatsGuest',
      'submitBooking',
      'fetchRegistered',
      'fetchPayment'
    ]),
    hackIcon () {
      console.log(this.$event)
    },
    selectedId (member) {
      return this.submitData.register_id.indexOf(member.register_id)
    },
    toNumeric ($event) {
      console.log($event.target.value, $event.target.name)
      if ($event.target.name === 'seats') {
        this.seats = Number($event.target.value)
        this.horizon = Math.ceil(this.seats / this.column)
      }
      if ($event.target.name === 'column') {
        this.column = Number($event.target.value)
        this.horizon = Math.ceil(this.seats / this.column)
      }
      if ($event.target.name === 'horizon') {
        this.horizon = Number($event.target.value)
        this.seats = Math.ceil(this.horizon * this.column)
      }
    },
    selectTest (seat) {
      console.log('seat_no:', seat)
      console.log('index:', this.selected.indexOf(seat))
      if (this.selected.indexOf(seat) === -1) {
        this.selected.push(seat)
        this.selected.sort(function (a, b) { return a - b })
      } else if (this.selected.indexOf(seat) > -1) {
        this.selected.splice(this.selected.indexOf(seat), 1)
      }
    },
    selectEvent (seat) {
      // console.log(this.getSeats.me.isChosen, this.getSeats.me.seat.is_leader)
      if (this.getSeats.group && this.getSeats.group.unChosen !== undefined) {
        if (seat !== null) {
          let humanSeat = seat.human_seat
          let seatNo = seat.seat_no
          let inSelected = this.selected.indexOf(humanSeat)
          let inBlank = this.blank.indexOf(humanSeat)
          let inSold = this.sold.indexOf(humanSeat)
          let arrAcount = []
          let arrId = []
          let inputOptions = new Promise((resolve) => {
            if (this.getSeats.me.seat.is_leader === true) {
              for (let i = 0; i < this.getSeats.group.unChosen.length; i++) {
                if (this.submitData.register_id.indexOf(this.getSeats.group.unChosen[i].register_id) < 0) {
                  arrAcount.push(this.getSeats.group.unChosen[i].account)
                  arrId.push(this.getSeats.group.unChosen[i].register_id)
                }
                if (i === this.getSeats.group.unChosen.length - 1) {
                  if (arrAcount.length > 0) {
                    resolve(arrAcount)
                    console.log('arrAcount: ', arrAcount)
                  } else {
                    this.$swal({
                      title: '座位: ' + seat.section + seat.human_seat_x + '-' + seat.human_seat_y,
                      text: '全數劃位完成，您沒有尚未選位的帳號',
                      confirmButtonText: '返回'
                    })
                  }
                }
              }
            } else if (this.getSeats.me.seat.is_leader === false && this.getSeats.me.isChosen === false) {
              if (this.submitData.register_id.indexOf(this.getSeats.me.seat.account.register_id) < 0) {
                arrAcount.push(this.getSeats.me.seat.account)
                arrId.push(this.getSeats.me.seat.register_id)
              }
              resolve(arrAcount)
            } else if (this.getSeats.me.seat.is_leader === false && this.getSeats.me.isChosen === true) {
              this.$swal({
                title: '座位已選擇',
                text: '您已經選擇好座位嘍',
                confirmButtonText: '返回'
              })
            }
          })
          if (this.getUser.registered.me.status === 4 && inSelected === -1 && inBlank === -1 && inSold === -1 && arrId.length > 0 && seat.is_scope_allow !== false && seat.status !== false && !seat.account) {
            console.log(inputOptions)
            this.$swal({
              title: '座位: ' + seat.section + seat.human_seat_x + '-' + seat.human_seat_y,
              text: '請指派帳號給此座位',
              showCancelButton: true,
              confirmButtonText: '確定',
              cancelButtonText: '取消',
              input: 'select',
              inputOptions: arrAcount,
              inputPlaceholder: '選擇帳號'
            }).then((res) => {
              if (res) {
                console.log('register_id: ', arrId[res], 'arrAccount: ', arrAcount[res], 'seatNo: ', seatNo)
                // 座位記號
                this.selected.push(humanSeat)
                this.selected.sort(function (a, b) { return a - b })
                let section = seat.section
                let seatX = seat.human_seat_x
                let seatY = seat.human_seat_y
                let account = arrAcount[res]
                this.memberInfo.push({
                  'section': section,
                  'human_seat_x': seatX,
                  'human_seat_y': seatY,
                  'account': account
                })
                // 傳送名單
                this.submitData.register_id.push(arrId[res])
                this.submitData.seat.push(seatNo)
                this.submitData.section.push(seat.section)
                console.log('確定')
                // this.$el.name = arrAcount[res]
              } else {
                this.$swal({
                  type: 'error',
                  html: '您未選擇帳號'
                })
              }
            }, (err) => {
              console.log(err)
            })
          } else if (this.getUser.registered.me.status === 4 && inSelected === -1 && inBlank === -1 && inSold === -1 && arrId.length > 0 && seat.is_scope_allow === false && !seat.account) {
            this.$swal({
              title: '您的票卷無法劃位此區域',
              text: '座位: ' + seat.section + seat.human_seat_x + '-' + seat.human_seat_y,
              confirmButtonText: '返回'
            })
          } else if (this.getUser.registered.me.status === 4 && inSelected === -1 && inBlank === -1 && inSold === -1 && arrId.length > 0 && seat.status === false && !seat.account) {
            this.$swal({
              title: '已劃位',
              text: '座位: ' + seat.section + seat.human_seat_x + '-' + seat.human_seat_y,
              confirmButtonText: '返回'
            })
          } else if (this.isMobile && !seat.account) {
            this.$swal({
              title: this.seatInfo.account,
              text: '座位: ' + seat.section + seat.human_seat_x + '-' + seat.human_seat_y,
              confirmButtonText: '返回'
            })
          }
          if (seat && this.submitData.seat.indexOf(seat.seat_no) > -1) {
            let index = this.submitData.seat.indexOf(seat.seat_no)
            // console.log(index)
            this.seatInfo.account = this.memberInfo[index].account
            this.seatInfo.seatNum = seat.section + seat.human_seat_x + '-' + seat.human_seat_y
            this.$swal({
              title: this.seatInfo.account,
              text: '座位: ' + seat.section + seat.human_seat_x + '-' + seat.human_seat_y,
              confirmButtonText: '返回'
            })
          }
        }
      } else if (this.isMobile) {
        if (seat && seat.status) {
          this.$swal({
            title: seat.account,
            text: '座位: ' + seat.section + seat.human_seat_x + '-' + seat.human_seat_y,
            confirmButtonText: '返回'
          })
        } else {
          this.$swal({
            title: '座位: ' + seat.section + seat.human_seat_x + '-' + seat.human_seat_y,
            confirmButtonText: '返回'
          })
        }
      }
      if (seat && seat.status) {
        this.$swal({
          title: seat.account,
          text: '座位: ' + seat.section + seat.human_seat_x + '-' + seat.human_seat_y,
          confirmButtonText: '返回'
        })
      }
    },
    showmobileInfo (seat) {
      console.log('showmobileInfo', seat)
    },
    showInfo ($event, seat) {
      if ($event.target && $event.relatedTarget && $event.relatedTarget.className === 'seats-wrap') {
        console.log('$event.target', $event.target)
        console.log('$event.relatedTarget', $event.relatedTarget.className)
        let x = $event.target.offsetLeft + $event.relatedTarget.offsetLeft - 20
        let y = $event.target.offsetTop + $event.relatedTarget.offsetTop - 90
        this.boxPosition.x = x
        this.boxSwitch = true
        this.seatInfo.seatNum = seat.section + seat.human_seat_x + '-' + seat.human_seat_y
        if (seat.account !== null) {
          this.seatInfo.account = seat.account
        } else if (this.submitData.seat.indexOf(seat.seat_no) > -1) {
          let index = this.submitData.seat.indexOf(seat.seat_no)
          // console.log(index)
          this.seatInfo.account = this.memberInfo[index].account
        } else {
          this.seatInfo.account = ''
          y = $event.target.offsetTop + $event.relatedTarget.offsetTop - 70
        }
        this.boxPosition.y = y
        console.log('x:' + x, 'y: ' + y, 'seat: ' + this.seatInfo.seatNum, seat.seat_no - 1, 'arrayIndex: ', seat.human_seat - 1)
      }
    },
    hideInfo () {
      this.boxSwitch = false
    },
    isSelected (seat) {
      // console.log(this.selected.includes(seat))
      if (this.selected.includes(seat) === true) {
        return true
      } else {
        return false
      }
    },
    isBlank (seat) {
      if (this.blank.includes(seat) === true) {
        return true
      } else {
        return false
      }
    },
    isSold (seat) {
      if (this.sold.includes(seat) === true) {
        return true
      } else {
        return false
      }
    },
    submitClear () {
      this.submitData = {
        register_id: [],
        section: [],
        seat: []
      }
      this.selected = []
      this.memberInfo = []
      console.log('clear')
    },
    submitButton () {
      let data = {
        register_id: this.submitData.register_id,
        seat: this.submitData.seat,
        section: this.getBookingSelected.area
      }
      // for (let i = 0; i < this.submitData.register_id.length; i++) {
      //   data.form.push({
      //     register_id: this.submitData.register_id[i],
      //     chosen: {
      //       seat: this.submitData.seat[i]
      //     }
      //   })
      // }
      console.log('page:', data)
      if (data.seat.length > 0) {
        this.submitDisabled = true
        this.submitBooking(data).then((res) => {
          this.isLoading = true
          this.$swal({
            type: 'success',
            title: '劃位成功',
            confirmButtonText: '返回',
            allowOutsideClick: false
          }).then((res) => {
            this.submitData = {
              register_id: [],
              section: [],
              seat: []
            }
            this.selected = []
            this.memberInfo = []
            this.fetchSeats(this.getBookingSelected.area).then((res) => {
              this.fetchRegistered().then(
                this.isLoading = false,
                this.submitDisabled = false
              )
            })
          })
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
@import '~stylesheets/components'
.account-wrap
  max-width: 586px
  margin: 0 auto 60px
  img
    max-width: 100%
  ul
    list-style: none
    padding: 0
    margin-bottom: 30px
    @extend %clearfix
    li
      float: left
      border: 1px solid $grey
      padding: 8px 16px
      margin: 4px
      +border-radius(6px)
      @extend %clearfix
      &:first-child
        margin-left: 0
      &:last-child
        margin-right: 0
      span
        float: left
        line-height: 40px
    &.selected-group
      @extend %clearfix
      .left
        float: left
        .icon
          background-image: url('~assets/icon-check.png')
          width: 40px
          height: 40px
      .right
        margin-left: 6px
        float: right
        @extend %clearfix
        .mySeat
          color: $green
          font-size: 12px
        .account
    &.unselected-group
      .icon
        background-image: url('~assets/icon-info.png')
        width: 40px
        height: 40px
.select-marked
  margin: 0 auto
  @extend %clearfix
  .marked
    margin: 8px 12px 0 0
    float: left
    border: 1px solid $grey
    padding: 6px 6px
    @extend %clearfix
    .icon
      width: 24px
      height: 24px
      margin: 0 6px 0 0
      display: block
      position: relative
      float: left
      &:after
        content: ''
        opacity: 0.8
        top: 0
        left: 0
        bottom: 0
        right: 0
        position: absolute
        z-index: 2
        background:
          position: center center
          repeat: no-repeat
          image: url('~assets/seat-available.png')
          size: 80%
    .text
      float: left
      font-size: 14px
      margin-top: 3px
    &.silent .icon
      background-color: #8470ad
    &.integrated .icon
      background-color: #93a733
    &.steam .icon
      background-color: #27d390
    &.lol .icon
      background-color: #b1aa8f
    &.fps .icon
      background-color: #d37c36
    &.blizzard .icon
      background-color: #198e99
    &.warfare .icon
      background-color: #a7344a
    &.home .icon
      background-color: #daa344
.select-wrap
  position: relative
  text-align: center
  width: 586px
  margin: 20px auto 0
  @media screen and (max-width: 640px)
    max-width: 100%
    overflow: auto
.stage
  margin: 30px auto 30px auto
  text-align: center
.seats-wrap
  position: relative
  margin: 0 auto
  width: 586px
  @extend %clearfix
.seat-number
  width: 30px
  height: 30px
  line-height: 30px
  text-align: center
  color: $grey
  font-weight: bold
  &.horizon
    margin: 0 10px
    display: inline-block
    @media screen and (max-width: 640px)
      margin: 0
      display: none
    // &:nth-child(n+1)
    //   margin:
    //     right: 10.5px
    // &:nth-child(12n+0)
    //   margin:
    //     right: 0
    // &:nth-child(12n+1)
    //   margin:
    //     left: 0
  &.column
    display: block
    position: absolute
    left: -30px
    line-height: 30px
    margin: 2px 0
    padding: 0
    @media screen and (max-width: 640px)
      display: none
.seat
  float: left
  width: 30px
  height: 30px
  margin: 4px 10px
  display: inline-block
  background:
    position: center center
    repeat: no-repeat
    image: url('~assets/seat-available.png')
    color: $grey-dark
  &.silent
    background-color: #8470ad
  &.integrated
    background-color: #93a733
  &.steam
    background-color: #27d390
  &.lol
    background-color: #b1aa8f
    // background-color: #9f8a65
  &.fps
    background-color: #d37c36
  &.blizzard
    background-color: #198e99
  &.warfare
    background-color: #a7344a
  &.home
    background-color: #daa344
  &:nth-child(odd)
    position: relative
    &:after
      content: ''
      user-select: none
      pointer-events: none
      display: block
      position: absolute
      right: -11px
      top: -4px
      height: 38px
      width: 1px
      background-color: #fff
  &:nth-child(even)
    +transform(rotate(180deg))
    div
      +transform(rotate(-180deg))
  // &:nth-child(n+1)
  //   margin:
  //     right: 10.5px
  // &:nth-child(12n+0)
  //   margin:
  //     right: 0
  // &:nth-child(12n+1)
  //   margin:
  //     left: 0
  &.blank
    visibility: hidden
    // opacity: 0.5
  &.selected
    background:
      image: url('~assets/seat-selected.png')
  &.sold
    background:
      image: url('~assets/seat-sold.png')
    &.isHacked
      background:
        image: url('~assets/seat-isHacked.png')
      // animation: handFlash 1.4s infinite ease-in-out both
      +transition(all, 0.8s, ease)
  &.notallow
    opacity: 0.2
    &.sold
      background:
        image: url('~assets/seat-sold.png')
  &.isMember
    background:
      image: url('~assets/seat-isMember.png') !important
    &.isMe
      background:
        image: url('~assets/seat-isMe.png') !important
.hover-box
  background-color: $black
  border: 1px solid $grey
  width: auto
  // height: 60px
  position: absolute
  padding: 8px
  z-index: 2
  text-align: left
  &:before
    content: ''
    position: absolute
    bottom: -8px
    left: 20px
    width: 0
    height: 0
    border-style: solid
    border-width: 8px 8px 0 8px
    border-color: $grey transparent transparent transparent
  &:after
    content: ''
    position: absolute
    bottom: -6px
    left: 22px
    width: 0
    height: 0
    border-style: solid
    border-width: 6px 6px 0 6px
    border-color: $black transparent transparent transparent
  .seatId
    color: $green
    font-size: 12px
  .account
    word-wrap: break-word

// copy form user
.border-styled
  border: 1px solid $grey
  padding: 16px
  +border-radius(2px)
.section-wrap
  font-size: 16px
  margin-bottom: 24px
  &:first-child
    margin-top: 36px
  &.success-msg
    line-height: 160%
  &.info-schedule
    .icon
      margin-right: 16px
    .content
      .status
        color: #fff
  .title
    font-weight: bold
    font-size: 18px
    margin-bottom: 16px
  .content
    color: $grey
  .payment-code
    padding: 0 8px
    list-style: none
    font-size: 20px
    li
      &:first-child
        font-size: 14px
        color: $grey
      &:last-child
        color: #fff
        font-weight: bold
        letter-spacing: 2px
  .payment-detail
    list-style: none
    padding: 0 8px
    display: table
    position: relative
    width: 100%
    li
      display: table-row
      span
        display: table-cell
        border-bottom: 1px solid $grey-dark
        color: #fff
        &:first-child
          color: $grey
          text-align
          font-size: 14px
      &:not(:first-child)
        span
          padding-top: 6px
      &:not(:last-child)
        span
          padding-bottom: 6px
      &:last-child
        span
          border-bottom: none

.scroll-tip
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(#000, 0.6)
  z-index: 10
  .content
    .arrow
      position: absolute
      width: 100%
      top: 50%
      left: 50%
      +transform(translate(-50%, -50%))
      animation: handFlash 1.4s infinite ease-in-out both
    .hand
      position: absolute
      top: 50%
      left: 50%
      width: 60px
      +transform(translate(-50%, -50%))
      animation: handSlide 1.4s infinite ease-in-out both
    .text
      position: absolute
      top: 50%
      left: 50%
      +transform(translate(-50%, 200%))
</style>



// WEBPACK FOOTER //
// selectSeats.vue?7b79c028